<ng-container *ngIf="data$ | async as data">
    <cx-media [container]="data.media"></cx-media>
</ng-container>
